import axios from "axios";
import { proxyUrl } from "../config";
import { setupInterceptorsTo } from "./Interceptors";
setupInterceptorsTo(axios);

export interface DocCategory
{
    id: number,
    name: string,
    slug: string
    createdAt?: string,
    updatedAt?: string
};

export interface Doc
{
    id: number,
    name: string,
    url: string,
    docCategoryId: string,
    docCategory?: DocCategory,
    createdAt?: string,
    updatedAt?: string
};

class DocsService
{
    public docAttachment = async (docId: number): Promise<any> =>
    {
        let url: string = `${proxyUrl}/docs/${docId}/attachment`
        const req = await axios.get(url, { responseType: 'blob' });
        return req;
    }

    public docsByCategoryDoc = async (categorySlug: string): Promise<Doc[]> =>
    {
        let url: string = `${proxyUrl}/docsCategories/${categorySlug}/docs`
        const req = await axios.get(url);
        return req.data;
    }
}

const docsService = new DocsService();
export default docsService;